import React, { useState } from "react"
import { withRouter } from "react-router-dom"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp"
import styled from "@emotion/styled"
import { colors } from "../../../library/constants/styles/colors"
import { devices } from "../../../library/constants/styles/responsive"
import { FAQArticles } from "./FAQArticles"

const Container = styled.div`
  padding: 15px;
  border-radius: 2px;
  background-color: ${colors.white};
  box-shadow: 0 0 2px 0 ${colors.black12};

  &:not(:last-child) {
    margin-bottom: 15px;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  p {
    max-width: 575px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @supports (display: grid) {
      flex: 1;
    }

    @media ${devices.xs} {
      max-width: 200px;
    }
  }
`;

const Status = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.black54};
`;

const Content = styled.div`
  padding-top: 15px;
`;

const FAQ = () => {
    return (
        <div className={"box"}>
            <div className="box__heading">
                Frequently asked questions
            </div>
            <div className="box__content">
                {FAQArticles.map((article, index) => (
                    <FAQArticle article={article} index={index} key={article.title}/>
                ))}
            </div>
        </div>
    );
};

const FAQArticle = ({article, index}) => {
    const [open, setOpen] = useState(false);

    const toggle = () => {
        setOpen(!open);
    };

    return (
        <Container>
            <Header onClick={toggle}>
                <p>Question {index + 1} - {article.title}</p>
                <Status>
                    {!open ? (
                        <KeyboardArrowDown className="color-black-38" onClick={toggle}/>
                    ) : (
                        <KeyboardArrowUp className="color-black-38" onClick={toggle}/>
                    )}
                </Status>
            </Header>
            {open && (
                <Content>
                    <p className={'mb8'}>Answer:</p>
                    {article.content}
                </Content>
            )}
        </Container>
    )
}

export default withRouter(FAQ);
